import queryApi from "../../queryApi";
import {message} from "antd";

const QUERY_URL = '/api/public/query';

const dataEIMZOSign = {
    "query": {
        "id": "EIMZO_SIGNATURES",
        "source": "EIMZO_SIGNATURES",
        "fields": [
            {   "column": "id", },
            {   "column": "tin", },
            {   "column": "filial", },
            {   "column": "pinfl", },
            {   "column": "serial_number", },
        ],
    }
}

const isHaveEmpCert = async ({empId}) => {

    dataEIMZOSign.query['filters'] = [{"column": "emp_id", "value": empId, "operator": "=", "dataType": "number"}];

    try {
        const response = await queryApi.post(QUERY_URL,
            JSON.stringify(dataEIMZOSign));
        //setLoading(false);
        return response?.data

    } catch (err) {
        if (!err?.response) {
            message.error(err.response?.data);
        } else if (err.response?.status === 400) {
            message.error(err.response?.data ||'INTERNAL');
        } else if (err.response?.status === 401) {
            message.error(err.response?.data ||'UNAUTHORIZED');
        } else if (err.response?.status === 404) {
            message.error(err.response?.data ||'NOT FOUND');
        } else {
            message.error(err.response?.data ||'OTHERS');
        }
        // errRef.current.focus();
    }

}

export default isHaveEmpCert